/*global google*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import ManageUsers from './ManageUsers/ManageUsers';
import Message from '../../Common/Message/Message';
import './Users.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
            validation: {
                client_name: {
                    valid: null,
                    msg: ''
                },
                billing_address_1: {
                    valid: null,
                    msg: ''
                },
                client_email: {
                    valid: null,
                    msg: ''
                },
                client_phone: {
                    valid: null,
                    msg: ''
                },
                billing_city: {
                    valid: null,
                    msg: ''
                },
                billing_country: {
                    valid: true,
                    msg: ''
                },
                billing_state: {
                    valid: true,
                    msg: ''
                },
                billing_contact: {
                    valid: null,
                    msg: ''
                },
                billing_zip: {
                    valid: null,
                    msg: ''
                }
            },
            isReadyToSubmit : false,
            isDisabled: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            stripe_url: '',
            code: '',    
            state: '',
            stripe_connected: false,
        };
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    handleChange = (e) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        const client = {...this.state.client};
        if (name === 'country') {
            this.state.client.country === 'US' ? client['state'] = 'AB' : client['state'] = 'AL'
        }
        client[name] = value;
        this.setState({ client });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, name, validationRegEx, e);
        }
    }

    handleChangePayout = (e) => {
        e.persist();
        let value = e.target.value;
        const name = e.target.name;
        if (e.target.type === "radio") {
            (value === "true") ? value = true : value = false;
        }
        const client = {...this.state.client};
        if (name === 'country') {
            this.state.client.country === 'US' ? client['state'] = 'AB' : client['state'] = 'AL'
        }
        client[name] = value;
        this.setState(
            { client },
            () => {
                this.updateClient();
            }
        );
    }

    handleBillingAddressChange = (value) => {
        const client = {...this.state.client};
        client.billing_address_1 = value;
        this.setState({
            client,
        });
    }

    handleFullBillingAddressChange = (value) => {
        const { client } = this.state;
        const { validation } = this.state;
        client['billing_address_1'] = `${value.address}`;
        client['billing_city'] = `${value.city}`;
        client['billing_country'] = `${value.country}`;
        client['billing_state'] = `${value.state}`;
        client['billing_zip'] = `${value.zip}`;
        validation['billing_address_1']['valid'] = true;
        validation['billing_city']['valid'] = true;
        validation['billing_country']['valid'] = true;
        validation['billing_state']['valid'] = true;
        validation['billing_zip']['valid'] = true;
        this.setState({
            client,
            validation
        }, () => {
            this.validateAllRequiredFields();
        });
    }

    validate = (value, name, validationRegEx, e) => {
        const validation = { ...this.state.validation };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value) && value !== '') {
            validation[name]['msg'] = strings.errorInvalid;
            isValid = false;
        }
        validation[name]['valid'] = isValid;
        this.setState({ validation }, () => { this.validateRequiredField(e) });
    }

    validateRequiredField = (e) => {
        const validation = { ...this.state.validation };
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[name]['msg'] = strings.errorRequired;
            validation[name]['valid'] = false;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.filter((item, index) => item.valid !== 'undefined').length;
        for (let type in validation) {
            if (validation[type]['valid']) {
                i--;
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }

    updateClient = () => {
        this.setMessage('', '', 'loading');
        const data = { ...this.state.client };
        data['shipping_fee'] = undefined;

        (async () => {
            try {
                // Check if url_short_name already exists
                const responseUrl = await checkURL(data.url_short_name);
                console.log(responseUrl);
                if(data.exists){
                    this.setMessage(window.general_strings.msg.oops, strings.urlAlreadyExist, 'error');
                } else {
                    const response = await putUpdatedClient(data);
                    if (response.data.error) {
                        let string = '';
                        response.data.error.details.forEach((detail) => {
                            string += detail.field + ' - ' + detail.message + '<br />';
                        });
                        this.setMessage(window.general_strings.msg.oops, string, 'error');
                        window.scroll(0,0);
                    } else {
                        this.setMessage('', '', '');
                        console.log('Client Update Response: ', response);

                        (async () => {
                            try {
                                const response = await getCurrentClient();
                                console.log('Current Client Response: ', response);
                                this.setState({ client: response.data.client || {} });
                            } catch (error) {
                                console.log(error);
                            }
                        })()
                
                        async function getCurrentClient() {
                            return await ApiRequest('/clients/current');
                        }
                    }
                }
            } catch (error) {
                this.setMessage(window.general_strings.msg.oops, error, 'error');
                window.scroll(0,0);
            }
        })()

        async function putUpdatedClient(data) {
            return await ApiRequest('/clients/current', {
                method: 'put',
                data
            });
        }

        async function checkURL(url_short_name) {
            return await ApiRequest(`/clients/url-short-name/${url_short_name}/exists`, {
                method: 'get'
            });
        }
    }

    getParams = async () => {
        this.setMessage('', '', 'loading');
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const state = urlParams.get('state');
        if (code && state) {
            this.setState({
                code,
                state,
            });
            try {
                const urlResponse = await postURL(code, state);
                console.log('urlResponse: ', urlResponse);
                if (urlResponse.data.success) {
                    this.setMessage(window.general_strings.msg.yay, 'Account successfully linked', 'success');
                    this.setState({
                        stripe_connected: true,
                    });
                } else {
                    if (urlResponse.data.error.code === 'client-has-existing-stripe-account') {
                        this.setMessage('', '', '');
                        this.setState({
                            stripe_connected: true,
                        });
                    } else {
                        this.setMessage(window.general_strings.msg.oops, urlResponse.data.error.message, 'error');
                        this.setState({
                            stripe_connected: false,
                        });
                    }
                }
                
                
            } catch (error) {
                console.log(error);
            }
        } else {
            this.setMessage('', '', '');
        }

		async function postURL(code, state) {
			return await ApiRequest(`/stripe/onboarding`, {
                method: 'POST',
                data: {
                    code,
                    state,
                }
            });
        }
    }

    getURL = async () => {
        try {
            const urlResponse = await getURL();
            console.log('urlResponse: ', urlResponse);
            if (urlResponse.data.url) {
                this.setState({
                    stripe_url: urlResponse.data.url
                });
            } else {
                if (urlResponse.data.error.code === 'client-has-existing-stripe-account') {
                    this.setState({
                        stripe_connected: true,
                    });
                }
            }
        } catch (error) {
            console.log(error);
        }

		async function getURL() {
			return await ApiRequest(`/stripe/onboarding/url`, {
                method: 'GET'
            });
        }
    }

    componentDidMount = () => {
        (async () => {
            try {
                const response = await getCurrentClient();
                console.log('Current Client Response: ', response);
                this.setState({ client: response.data.client || {} });
            } catch (error) {
                console.log(error);
            }
        })()

        async function getCurrentClient() {
            return await ApiRequest('/clients/current');
        }

        let validation = { ...this.state.validation };
        for (let type in validation) {
            validation[type]['valid'] = true;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());

        this.getURL();
        this.getParams();
    }

    componentWillReceiveProps(props) {
        if(props.isUpdateClient){
            this.updateClient();
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="container">
                    <Message
                        message={this.state.message}
                    />
                </div>
                <form>
                    <ManageUsers
                        user={this.props.user}
                    />
                </form>
            </React.Fragment>
        );
    }
}

Users.propTypes = {
}

export default Users;



// WEBPACK FOOTER //
// ./src/components/Client/Users/Users.js